const BUTTON_TRANSITION_DURATION_MS = 150;
const buttonCls = "dibbfnurzt";
const bubbleCls = "dibbq2huh3";
const infoPoppercls = "dibi1cghyiu";
const infoCls = "dibisjmjt5";
const infoHeadingCls = "dibi3u6kc5";
const infoCloseButtonCls = "dibim6e70y";

export { BUTTON_TRANSITION_DURATION_MS, bubbleCls, buttonCls, infoCloseButtonCls, infoCls, infoHeadingCls, infoPoppercls };
import "./guide-bubble.style.linaria.module.css";
//# sourceMappingURL=guide-bubble.style.js.map
